import { Controller } from "@hotwired/stimulus"

// "Resend code" on the wizard's verify step. The server says how long until
// another code may be sent; the button counts down until then. The server
// checks the wait again, so this is only a hint.
export default class extends Controller {
  static targets = ["button"]
  static values = { seconds: Number }

  connect() {
    this.label = this.buttonTarget.textContent.trim()
    this.endsAt = Date.now() + this.secondsValue * 1000
    this.tick()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  tick() {
    const remaining = Math.ceil((this.endsAt - Date.now()) / 1000)
    if (remaining <= 0) {
      this.buttonTarget.disabled = false
      this.buttonTarget.textContent = this.label
      return
    }

    this.buttonTarget.disabled = true
    const minutes = Math.floor(remaining / 60)
    const seconds = String(remaining % 60).padStart(2, "0")
    this.buttonTarget.textContent = `${this.label} in ${minutes}:${seconds}`
    this.timeout = setTimeout(() => this.tick(), 1000)
  }
}
